module.exports = __webpack_public_path__ + "img/t3-bronze.dc9f214d.jpg";